module.exports = __webpack_public_path__ + "static/img/timeline-equals.2d98fb75.svg";